import { useMemo } from 'react';

import get from 'lodash/get';

import { FormAutocompleteField } from '@sbv-clients/ui-forms';

import { useAdminTimezoneGet } from '../../services/admin';

const TimezoneSelectField = () => {
  const { data } = useAdminTimezoneGet();
  const timezones = data?.data;
  const options = useMemo(
    () =>
      timezones?.map((item) => {
        const id = get(item, 'id') || '';
        const name = get(item, 'name') || '';
        return { id, value: id, label: name };
      }),
    [timezones]
  );
  return (
    <FormAutocompleteField
      fullWidth
      id="timezone"
      name="timezone"
      label="Timezone"
      options={options}
    />
  );
};

export default TimezoneSelectField;
